
    <form #addPriceTemplateForm='ngForm' id="add-price-template-form">
        <div class="grid grid-cols-12 gap-4   px-6 mt-6">


            <div class="mb-4 col-span-12">
                <h4 class="mb-2 mt-0">Şablon Adı</h4>
                <input  class="w-full" pInputText id="Title" name="Title" #Title='ngModel' aria-describedby="Title-help" [(ngModel)]="priceTemplate.Title" required/>
                <small class="text-red-500">
                    @if (showError || (addPriceTemplateForm.form.invalid && (Title.dirty || Title.touched)
                    )) {
                        @if (Title.errors?.['required']) {
                            Lütfen şablon adı giriniz.*
                        }

                    }
                </small>
            </div>
        </div>
    </form>




<div class=" mx-6 flex bg-surface-50 dark:bg-surface-800 border border-surface rounded-border">
    <h4 class="px-6 py-1 my-2">Temel Satış Fiyatı</h4>
</div>

<div class=" mx-6 pb-2 pt-6  border-surface ">
        <div class="w-full col-span-12  items-center justify-center gap-4 ">
            <div class="grid grid-cols-12 gap-4  ">


                <div class="mb-4 col-span-12 lg:col-span-3">
                    <label  class="m-form-label">Kaynak Satış Fiyatı</label>
                    <p-select
                      class="w-full"
                            inputId="currencyFields"  appendTo="body"
                            [(ngModel)]="priceTemplate.SellPrice.Source" [options]="priceSourceAll" optionLabel="header"
                            optionValue="field" placeholder="Fiyat Kaynağını Seçiniz"></p-select>
                </div>



                <div class="mb-4 col-span-12 lg:col-span-3 ">
                    <label  class="m-form-label !flex justify-center ">Yüzdelik
                        Kullan</label>
                    <div  class="flex items-center justify-center mt-4">
                        <p-toggleswitch
                                [(ngModel)]="priceTemplate.SellPrice.IsPercent" [trueValue]="true" [falseValue]="false"
                                inputId="SellPriceChangeIsPercent"></p-toggleswitch>
                    </div>
                </div>
                <div class="mb-4 col-span-12 lg:col-span-3 ">
                    <label class="m-form-label">İşlem Türü</label>
                    <p-select
                      class="w-full"
                            inputId="currencyFields"  appendTo="body"
                            [(ngModel)]="priceTemplate.SellPrice.IncreaseDecreaseType"
                            [options]="providerProductIncrementTypeOptions" optionLabel="header" optionValue="field"
                            placeholder="Para birimi seçiniz"></p-select>
                </div>
                <div class="mb-4 col-span-12 lg:col-span-3 ">
                    @if (priceTemplate.SellPrice.IsPercent) {
                        <label  class="m-form-label">
                            Yüzdelik {{ priceTemplate.SellPrice.IncreaseDecreaseType === ProviderProductIncrementTypeEnum.Up ? 'Artış' : 'Azalış' }}</label>
                        <p-inputNumber
                          [allowEmpty]="false"
                                  inputStyleClass="!text-sm"
                                  prefix="%"
                                [(ngModel)]="priceTemplate.SellPrice.ChangeAmount" mode="decimal" [showButtons]="true"
                                inputId="minmax-buttons" [min]="0" [max]="100"></p-inputNumber>
                    } @else {
                        <label  class="m-form-label">
                            Miktar {{ priceTemplate.SellPrice.IncreaseDecreaseType === ProviderProductIncrementTypeEnum.Up ? 'Artış' : 'Azalış' }}</label>
                        <p-inputNumber
                          [allowEmpty]="false"
                          inputStyleClass="!text-sm"
                                [(ngModel)]="priceTemplate.SellPrice.ChangeAmount"
                                [showButtons]="true" inputId="stacked" mode="currency"
                                [currency]="baseCurrency |currencyMagenty"  ></p-inputNumber>
                    }
                </div>

            </div>


        </div>
</div>

<div class="col-span-12 ">
        <div class="grid grid-cols-12 gap-4   ">
            <div class="col-span-12 gap-4 flex justify-center items-center">
                <label class="font-medium">Üstü Çizili
                    Fiyat Kullan</label>
                <div
                >
                    <p-toggleswitch
                            [(ngModel)]="priceTemplate.IsUseStrikeThroughPrice" [trueValue]="true" [falseValue]="false"
                            inputId="SellPriceChangeIsPercent"></p-toggleswitch>
                </div>
            </div>
</div>

@if (priceTemplate.IsUseStrikeThroughPrice) {

    <div class="mx-4 flex bg-surface-50 dark:bg-surface-800 border border-surface rounded-border">
        <h4 class="px-6 py-1 my-2">Üstü Çizili Fiyat</h4>
    </div>
    <div class="mx-4 mb-6 pb-2 pt-6">
        <div class="w-full col-span-12 items-center justify-center gap-4 ">
            <div class="grid grid-cols-12 gap-4   ">
                    <div class="mb-4 col-span-12 lg:col-span-3">
                        <label  class="m-form-label">Kaynak Üstü Çizili Fiyat</label>
                        <p-select
                          class="w-full"
                                inputId="currencyFields"  appendTo="body"
                                [(ngModel)]="priceTemplate.StrikeThroughPrice.Source" [options]="priceSourceAll"
                                optionLabel="header" optionValue="field" placeholder="Fiyat Kaynağını Seçiniz"></p-select>
                    </div>



                    <div class="mb-4 col-span-12 lg:col-span-3 ">

                        <label  class="m-form-label !flex justify-center">Yüzdelik
                            Kullan</label>
                        <div  class="flex items-center justify-center mt-4">
                            <p-toggleswitch
                                    [(ngModel)]="priceTemplate.StrikeThroughPrice.IsPercent" [trueValue]="true" [falseValue]="false" inputId="SellPriceChangeIsPercent"></p-toggleswitch>
                        </div>
                    </div>
                    <div class="mb-4 col-span-12 lg:col-span-3 ">
                        <label for="currencyFields" class="m-form-label">İşlem Türü</label>
                        <p-select
                          class="w-full"
                                inputId="currencyFields" id="currencyFields" appendTo="body"
                                [(ngModel)]="priceTemplate.StrikeThroughPrice.IncreaseDecreaseType"
                                [options]="providerProductIncrementTypeOptions" optionLabel="header" optionValue="field"
                                placeholder="Para birimi seçiniz"></p-select>
                    </div>
                    <div class="mb-4 col-span-12 lg:col-span-3">
                        @if (priceTemplate.StrikeThroughPrice.IsPercent) {
                            <label for="SellPriceChangeValue0" class="m-form-label">
                                Yüzdelik {{ priceTemplate.StrikeThroughPrice.IncreaseDecreaseType === ProviderProductIncrementTypeEnum.Up ? 'Artış' : 'Azalış' }}</label>
                            <p-inputNumber
                              [allowEmpty]="false"
                              inputStyleClass="!text-sm" id="SellPriceChangeValue0" prefix="%"
                                    [(ngModel)]="priceTemplate.StrikeThroughPrice.ChangeAmount" mode="decimal"
                                    [showButtons]="true" inputId="minmax-buttons" [min]="0" [max]="100"></p-inputNumber>
                        } @else {
                            <label for="SellPriceChangeValue" class="m-form-label">
                                Miktar {{ priceTemplate.StrikeThroughPrice.IncreaseDecreaseType === ProviderProductIncrementTypeEnum.Up ? 'Artış' : 'Azalış' }}</label>
                            <p-inputNumber
                              [allowEmpty]="false"
                              inputStyleClass="!text-sm" id="SellPriceChangeValue"
                                    [(ngModel)]="priceTemplate.StrikeThroughPrice.ChangeAmount" [showButtons]="true"
                                    inputId="stacked" mode="currency"
                                    [currency]="baseCurrency |currencyMagenty" ></p-inputNumber>
                        }
                    </div>



        </div>
        </div>

</div>
}






<div class="col-span-12 p-0 px-4">
    <div class="h-8"></div>
    <div class="mt-6">
    <div class="-mt-4">
        <p-divider align="center"   >
            <h4 class="block rounded-border p-2">Kural Tablosu</h4>
        </p-divider>
    </div>

    <p-table
            id="rule-table"
            responsiveLayout="stack" breakpoint="992px"
            styleClass="p-datatable-striped border border-surface mt-6 "
            [value]="priceTemplate.Rules"  [tableStyle]="{'min-width': '18rem' } "
            [scrollable]="true" scrollHeight="300px"
            [style]="{'z-index':1}"
            stripedRows
         (onRowReorder)="refreshSorting(priceTemplate.Rules)" [reorderableColumns]="true">
    <ng-template #caption>
        <div class="col-span-12">
            <div class="flex justify-end items-center">
            <!--    <small class="text-red-500 font-md">
                @if (showError && priceTemplate.Rules.length===0)
                {
                        Lütfen kural tablosuna 1 adet kural ekleyiniz.
                }
                </small>

-->
                <p-button (onClick)="newRulesModalOpen()" label="Fiyat Kuralı Ekle"  styleClass="-mr-1" [outlined]="true"></p-button>

            </div>
        </div>



    </ng-template>
    <ng-template #header let-columns>
        <tr >
            <th style="width:3rem"></th>
            <th>Sıralama</th>
            <th>Düzenleme</th>
            <th>Açıklama</th>
            <th>Yüzdelik Kullan</th>
            <th>Artış Değeri</th>
            <th>Fiyat Aralıkları</th>
            <th>Silme</th>
        </tr>
    </ng-template>
    <ng-template #body let-rowData let-columns="columns" let-index="rowIndex">
        <tr [pReorderableRow]="index" >
            <td>
                <span class="p-column-title"></span>
                <span class="pi pi-bars" pReorderableRowHandle></span>
            </td>
            <td>
                <span class="p-column-title">Sıralama</span>
                {{ rowData.Sort }}
            </td>
            <td>
                <span class="p-column-title">Düzenleme</span>
                <button pButton [text]="true" class="hover:shadow-none focus:shadow-none" >
                    <img
                            (click)="updateRulesModalOpen(rowData)"
                            alt="edit"
                            src="assets/gif/pause/edit.png" height="30" width="30" magentyHovergif
                            [hoverGif]="'assets/gif/edit.gif'">
                </button>
            </td>
            <td>
                <span class="p-column-title">Düzenleme</span>
                {{ rowData.Title }}
            </td>
            <td>
                <span class="p-column-title">Yüzdelik Kullan</span>
                {{ rowData.IsPercent ? 'Evet':'Hayır' }}
            </td>
            <td>
                <span class="p-column-title">Artış Değeri</span>
                {{ rowData.DirectAmount }}
            </td>
            <td>
                <span class="p-column-title">Fiyat Aralıkları</span>

                    <ul>
                        @if(rowData.Ranges.length>0){
                            <li class="whitespace-nowrap list-none text-right lg:text-left">Min > ... <= Max -> Fiyat</li>
                            @for (price of rowData.Ranges; track $index) {
                                <li class="whitespace-nowrap list-none text-right lg:text-left">
                                    <tui-money
                                            [colored]="true" [currency]="baseCurrency |currencyMagenty "
                                            [value]="price.MinAmount"></tui-money>
                                    > ... <=
                                    <tui-money
                                            [colored]="true" [currency]="baseCurrency |currencyMagenty "
                                            [value]="price.MaxAmount"></tui-money>
                                    ->
                                  @if(rowData.IsPercent){
                                    %{{price.ChangeAmount}}
                                  }
                                  @else{
                                    <tui-money
                                            [colored]="true" [currency]="baseCurrency |currencyMagenty "
                                            [value]="price.ChangeAmount"></tui-money>
                                  }

                                </li>
                            }
                        }

                    </ul>
                </td>
                <td>
                    <span class="p-column-title">Silme</span>

                    <button pButton
                            [rounded]="true"
                            class="-mr-4"
                            severity="danger"
                            icon="pi pi-trash"
                            [text]="true"
                            (click)="deleteRuleItemDialog(rowData)" ></button>
                </td>

            </tr>
        </ng-template>
    </p-table>

</div>







<p-dialog
        [(visible)]="visible3" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}"
        [style]="{width: '55vw'}" header="Fiyat Kuralı Ekle" [draggable]="false" [resizable]="false">

    @if (rules) {

            <div class="grid grid-cols-12 gap-4   px-6 mt-2">
                <form #rulesForm="ngForm" class="col-span-12">
                    <div class="mb-4 col-span-12  ">

                        <label class="m-form-label !flex justify-center">Kural Açıklaması</label>
                        <div class="flex items-center justify-center">
                            <input  #Title="ngModel" name="Title"  class="w-full"
                                    pInputText aria-describedby="username-help" [(ngModel)]="rules.Title" [required]="true"/>


                        </div>
                        <small id="Title-help" class="text-red-500">
                            @if (rulesShowError || (rulesForm.form.invalid && (Title.dirty || Title.touched)
                            )) {
                                @if (Title.errors?.['required']) {
                                   Lütfen kural açıklaması giriniz.*
                                }
                            }
                        </small>
                    </div>
                </form>


                <div class="mb-4 col-span-6  ">
                    <label
                            class="m-form-label !flex justify-center text-center">Yüzdelik
                        Kullan</label>
                    <div
                            class="flex items-center justify-center">
                        <p-toggleswitch

                                (ngModelChange)="changeSwitch()"
                                [(ngModel)]="rules.IsPercent" [trueValue]="true" [falseValue]="false"
                                inputId="SellPriceChangeIsPercent"></p-toggleswitch>

                    </div>
                </div>
                <div class="mb-4 col-span-6 ">
                    <label class="m-form-label !flex justify-center text-center">Koşul Kullan</label>
                    <div
                            class="flex items-center justify-center">
                        <p-toggleswitch

                                (ngModelChange)="changeSwitch()"
                                [(ngModel)]="rules.IsConditional" [trueValue]="true" [falseValue]="false"
                                inputId="SellPriceChangeIsPercent"></p-toggleswitch>
                    </div>
                </div>


            </div>
            @if (rules.IsConditional) {

<div class="px-4">


    <div>
        <p-divider align="center" >
            <h4 class="block rounded-border p-2">Koşul Tablosu</h4>
        </p-divider>
    </div>


    <p-table [value]="rules.Ranges"
             responsiveLayout="stack" breakpoint="992px"
             styleClass="p-datatable-striped border border-surface "  stripedRows
             (onRowReorder)="refreshSorting(rules.Ranges)" [reorderableColumns]="true"
             [tableStyle]="{'min-width': '25rem'}" >
        <ng-template #caption>

          <div class="grid grid-cols-12 gap-4 px-2 w-full">

            <!-- Min -->
            <div class="col-span-12 lg:col-span-3 mb-4 flex flex-col gap-2">
              <label class="m-form-label">Min</label>
              <p-inputNumber
                [allowEmpty]="false"
                [min]="0"
                [max]="range.MaxAmount !== 0 ? range.MaxAmount - 1 : 9999999999"
                [(ngModel)]="range.MinAmount"
                [showButtons]="true"
                inputId="stacked"
                mode="currency"
                class="max-w-full"
                inputStyleClass="max-w-full"
                [currency]="baseCurrency | currencyMagenty"

              ></p-inputNumber>
            </div>

            <!-- Orta label ( >...<= ) -->
            <div class="hidden lg:flex items-end justify-center col-span-12 lg:col-span-1  mb-6">
              <label class="font-bold block  text-xl">>...<=</label>
            </div>

            <!-- Max -->
            <div class="col-span-12 lg:col-span-3 mb-4 flex flex-col gap-2">
              <label class="m-form-label">Max</label>
              <p-inputNumber
                [allowEmpty]="false"
                [min]="range.MinAmount !== 0 ? range.MinAmount + 1 : 0"
                [(ngModel)]="range.MaxAmount"
                [showButtons]="true"
                inputId="stacked"
                mode="currency"
                class="max-w-full"
                inputStyleClass="max-w-full"
                [currency]="baseCurrency | currencyMagenty"

              ></p-inputNumber>
            </div>

            <!-- Yüzdelik veya Miktar Artış -->
            <div class="col-span-12 lg:col-span-3 mb-4 flex flex-col gap-2">
              <ng-container *ngIf="rules.IsPercent; else amountTemplate">
                <label class="m-form-label">Yüzdelik Artış</label>
                <p-inputNumber
                  [allowEmpty]="false"
                  prefix="%"
                  [(ngModel)]="range.ChangeAmount"
                  mode="decimal"
                  [showButtons]="true"
                  inputId="minmax-buttons"
                  [min]="0"
                  [max]="100"
                  class="max-w-full"
                  inputStyleClass="max-w-full"
                ></p-inputNumber>
              </ng-container>
              <ng-template #amountTemplate>
                <label class="m-form-label">Miktar Artış</label>
                <p-inputNumber
                  [allowEmpty]="false"
                  [(ngModel)]="range.ChangeAmount"
                  [showButtons]="true"
                  inputId="stacked"
                  mode="currency"
                  class="max-w-full"
                  inputStyleClass="max-w-full"
                  [currency]="baseCurrency | currencyMagenty"

                ></p-inputNumber>
              </ng-template>
            </div>

            <!-- Ekle Butonu -->
            <div
              class="col-span-12 lg:col-span-2 mb-4 flex items-end justify-center"
              pTooltip="Maksimum değeri ve Miktar artışı değeri sıfırdan büyük olmalıdır"
              tooltipPosition="top"
              [tooltipDisabled]="!(range.MinAmount > range.MaxAmount || range.MaxAmount === 0 || range.ChangeAmount === 0)"
            >
              <p-button
               styleClass="w-full"
                icon="pi pi-check"
                [disabled]="range.MinAmount > range.MaxAmount || range.MaxAmount === 0 || range.ChangeAmount === 0"
                class="mt-4 lg:mt-0"
                (click)="addRange()"
                label="Ekle"
              ></p-button>
            </div>

           @if(showError) {
             <div class="col-span-12 px-1">
               <small id="SellPrice-help" class="text-red-500 font-normal">
                 Zaten varolan bir koşulu eklemeye çalışıyorsunuz. Lütfen sayıları değiştirip tekrar deneyiniz.
               </small>
             </div>
           }
            @if(rulesShowError && rules.Ranges.length === 0) {

              <div class="col-span-12 px-1">
                <div *ngIf="rulesShowError && rules.Ranges.length === 0">
                  <small class="text-red-500 font-normal">
                    Lütfen tabloya en az 1 adet koşul ekleyin.
                  </small>
                </div>
              </div>
            }
          </div>



        </ng-template>
                        <ng-template #header>
                            <tr>
                                <th style="width:3rem"></th>
                                <th>Sıralama</th>
                                <th>Min</th>
                                <th>Max</th>
                                <th>Artış Değeri</th>
                                <th>Silme</th>

                            </tr>
                        </ng-template>

                        <ng-template #body let-rowData let-columns="columns" let-index="rowIndex">
                            <tr [pReorderableRow]="index" >
                            <td>
                                <span class="p-column-title"></span>
                                <span class="pi pi-bars" pReorderableRowHandle></span>
                            </td>

                             <td>
                                 <span class="p-column-title">Sıralama</span>
                               {{rowData.Sort}}
                            </td>
                            <td>
                                <span class="p-column-title">Min</span>
                                    <tui-money
                                            [colored]="true" [currency]="baseCurrency |currencyMagenty "
                                            [value]="rowData.MinAmount"></tui-money>

                            </td>
                             <td>
                                 <span class="p-column-title">Max</span>
                                    <tui-money
                                            [colored]="true" [currency]="baseCurrency |currencyMagenty "
                                            [value]="rowData.MaxAmount"></tui-money>

                             </td>
                                <td>
                                    <span class="p-column-title">Artış Değeri</span>
                                    @if (rules.IsPercent) {
                                        <b>% {{ rowData.ChangeAmount }}</b>
                                    } @else {
                                        <tui-money
                                                [colored]="true" [currency]="baseCurrency |currencyMagenty "
                                                [value]="rowData.ChangeAmount"></tui-money>
                                    }


                                </td>
                                <td>
                                    <span class="p-column-title">Silme</span>
                                    <button pButton [rounded]="true" severity="danger" icon="pi pi-trash" [text]="true" (click)="deleteRangeItemDialog(rowData)" ></button>

                                </td>

                            </tr>
                        </ng-template>
                    </p-table>
</div>

            } @else {
                <div class="grid grid-cols-12 gap-4   px-6">
                    <div class="mb-4 col-span-12 ">
                        @if (rules.IsPercent) {
                            <label class="m-form-label">
                                Yüzdelik Artış</label>
                            <p-inputNumber
                              [allowEmpty]="false"
                              class="w-full"
                              inputStyleClass="!text-sm"
                                #DirectAmount="ngModel" name="DirectAmount"

                                  prefix="%" [(ngModel)]="rules.DirectAmount" mode="decimal"
                                    [showButtons]="true" inputId="minmax-buttons" [min]="0" [max]="100" [required]="true"></p-inputNumber>


                        } @else {

                            <label class="m-form-label">
                                Miktar Artış</label>
                            <p-inputNumber
                              [allowEmpty]="false"
                              class="w-full"
                                #DirectAmount="ngModel" name="DirectAmount"
                                [min]="0"
                                inputStyleClass="!text-sm" [(ngModel)]="rules.DirectAmount" [showButtons]="true"
                                    inputId="stacked" mode="currency"
                                    [currency]="baseCurrency |currencyMagenty" ></p-inputNumber>


                        }

                    </div>
                </div>
            }



    }


    <ng-template #footer>
        <div class="px-6 ">
            <div class="border-t border-surface pt-4">

            <span pTooltip="Maksimum değeri ve Miktar artışı değeri sıfırdan büyük olmalıdır"
                  [tooltipDisabled]="!(!rules?.IsConditional && rules?.DirectAmount ===0)"
                  tooltipPosition="top"
            >
                <button

                        [disabled]="!rules?.IsConditional && rules?.DirectAmount ===0"
                        class="-mr-1"
                        pButton (click)="addUpdatePriceRule()" [label]="rules?.Sort===0 ?'Kural Ekle':'Kural Güncelle'"></button>
            </span>


            </div>
        </div>

    </ng-template>



</p-dialog>

<div class="h-16 col-span-12 mt-4"></div>

<div class="fixed z-10 left-0 bottom-0 w-full bg-white dark:bg-surface-900 px-12 ">
    <div class=" border-t border-surface"
         style="margin-right:5px"
    >
        <div class=" mb-6 flex justify-end items-center m-4 mr-0">

            <span >
                <button


                        pButton (click)="addUpdatePriceTemplate()" [label]="this.priceTemplate.Id.length>0 ? 'Güncelle':'Kaydet'"></button>
               <!--[disabled]="priceTemplate.SellPrice.ChangeAmount===0 || (priceTemplate.IsUseStrikeThroughPrice  && priceTemplate.StrikeThroughPrice.ChangeAmount!==0 && priceTemplate.SellPrice.ChangeAmount>=priceTemplate.StrikeThroughPrice.ChangeAmount)"-->
            </span>


        </div>
    </div>

</div>


</div>
</div>